import React, {useEffect, useRef} from 'react';
import styles from './TextArea.module.scss';
import cn from 'classnames';

export interface ITextAreaProps {
  value: string | number;
  onChange: (value: string) => void;
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement, Element>) => void;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement, Element>) => void;
  label?: string;
  className?: string;
  placeholder?: string;
  name?: string;
  title?: string;
  disabled?: boolean;
  size?: 'sm' | 'lg';
  selectOnFocus?: boolean;
  iconAfter?: JSX.Element;
  autoFocus?: boolean;
  autoHeight?: boolean;
  minHeight?: number;
}
export const TextArea: (props: ITextAreaProps) => JSX.Element = (props) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (props.autoFocus && inputRef.current) inputRef.current.focus();
    if (inputRef?.current)
    {
        changeHeight(inputRef.current);
    }
  }, [props.autoFocus]);
  const {autoHeight = true} = props;
  const changeHeight = (el:any)=>{
      if (!autoHeight)
          return;
      el.style.height = '0px';
      const scroll_h = el.scrollHeight;
      const min_h = props.minHeight || 40;
      el.style.height = el.value && scroll_h > min_h ? el.scrollHeight+'px'
          : `${min_h}px`;
  };
  const onChangePlusH = (ev:any)=>{
      ev.persist();
      changeHeight(ev.target);
      props.onChange(ev.target.value);
  };
  return (
    <div
      className={cn(
        styles.root,
        props.className,
        props.size && styles[`input--${props.size}`],
      )}>
      {props.label && <label>{props.label}</label>}
      <textarea
        ref={inputRef}
        name={props.name}
        placeholder={props.placeholder}
        title={props.title}
        aria-label={props.title || props.name}
        value={props.value}
        onChange={(e) => {
          onChangePlusH(e);
        }}
        disabled={props.disabled}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
      />
      {props.iconAfter ? (
        <div className={cn(styles.iconAfter, props.label && styles.withLabel)}>
          {props.iconAfter}
        </div>
      ) : null}
    </div>
  );
};
